import { FC } from 'react';

import { InfoBanner } from '@/shared/ui';

import { usePurchasePrompt } from '@/entities/billing';

import { useStorageBanners } from '../../hooks';
import { InfoBannersGroup } from '../InfoBannersGroup/InfoBannersGroup';
import { SubscriptionPurchasePromptBanner } from '../SubscriptionPurchasePromptBanner/SubscriptionPurchasePromptBanner';

type HeaderBannersProps = {
  className?: string;
};

export const HeaderBanners: FC<HeaderBannersProps> = (props) => {
  const { className } = props;

  const { shouldShow: shouldShowSubscriptionPurchasePromptBanner, isOwner } =
    usePurchasePrompt();
  const { shouldShowStorageBanner, storageBannerProps } = useStorageBanners();

  const shouldShowBannerGroup =
    shouldShowSubscriptionPurchasePromptBanner || shouldShowStorageBanner;

  if (!shouldShowBannerGroup) {
    return null;
  }

  return (
    <InfoBannersGroup className={className}>
      {shouldShowSubscriptionPurchasePromptBanner && (
        <SubscriptionPurchasePromptBanner isOwner={isOwner} />
      )}

      {shouldShowStorageBanner && storageBannerProps && (
        <InfoBanner icon="alert" {...storageBannerProps} />
      )}
    </InfoBannersGroup>
  );
};
